<template>
  <div>
    <yvalues
      :yvalues="yvalues"
      :numberfields="numberfields"
      @ychange="ychange"
    ></yvalues>
    <bar ref="bar" :chartdata="tdata" :options="options"></bar>
    <el-radio-group @change="timemodelchange" v-model="timemodel" size="mini">
      <el-radio-button
        v-for="timemodel in timemodels"
        :key="timemodel"
        :label="timemodel"
      ></el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
import bar from "./charttype/bar";
import yvalues from "./yvalues";
import palette from "google-palette";
export default {
  components: { bar, yvalues },

  mounted() {
    let self = this;
    //  console.log(data)
    // this.tdata.datasets[0].data = data;

    setTimeout(function () {
      self.chartprocess(self.chartdatatime);
      self.$refs.bar.render();
    }, 0);
  },

  watch: {
    chartdatatime: {
      handler: function (newval, oldVal) {
        // this.tdata.datasets[0].data = newval;
        this.chartprocess(newval);
        this.$refs.bar.render();
      },
      deep: true,
    },
  },
  computed: {
    timemodel: {
      get() {
        return this.$store.state.timemodel;
      },
      set(val) {
        this.options.scales.xAxes[0].time.unit = val;
        switch (val) {
          case "year":
            this.options.scales.xAxes[0].time.tooltipFormat = "YYYY";
            break;
          case "month":
            this.options.scales.xAxes[0].time.tooltipFormat = "YYYY/MM";
            break;
          case "day":
            this.options.scales.xAxes[0].time.tooltipFormat = "YYYY/MM/DD";
        }

        this.$store.commit("settimemodel", val);
      },
    },
    chartdatatime() {
      return this.$store.state.chartdatatime;
    },
    dbprocessing() {
      return this.$store.state.dbprocessing;
    },
    numberfields() {
      return this.$store.state.numberfields;
    },
    yvalues() {
      return this.$store.state.yvalues;
    },
  },
  methods: {
    chartprocess(chartdatatime) {
      // console.log(chartdatatime)
      let datas = chartdatatime;
      let datasets = [];
      for (let i = 0; i < datas.length; i++) {
        let dataobj = {};
        dataobj.data = datas[i];
        dataobj.backgroundColor = "#" + palette("mpn65", datas.length)[i]; //需与yvalues中的color定义一致
        datasets.push(dataobj);
      }
      this.tdata.datasets = datasets;
    },

    timemodelchange(val) {
      // this.options.scales.xAxes[0].time.unit = val;
      this.$axios.fetchremotechartdata("time");
    },
    ychange(ar) {
      this.$store.commit("setyvalues", ar); //[ar[ar.length - 1]]
      this.$axios.fetchremotechartdata("time");
      // this.$emit("ychange")
    },
  },
  data() {
    return {
      timemodels: ["year", "month", "day"],
      tdata: {
        datasets: [
          {
            data: [], //{x:"2012/01/20",y:20},{x:"2012/01/25",y:40},{x:"2019/02/20",y:10}
            backgroundColor: "red",
          },
        ],
      },
      options: {
        maintainAspectRatio: false,

        tooltips: {
          intersect: false,
          mode: "index",
          callbacks: {
            title: function () {
              return "";
            },
            beforeLabel: function (tooltipItem, myData) {
              //console.log(tooltipItem)
              return tooltipItem.xLabel;
            },
            label: function (tooltipItem, myData) {
              return new Intl.NumberFormat().format(tooltipItem.yLabel);
            },
          },
        },

        legend: { display: false },

        title: {
          display: false,
          text: "表格数据图",
        },

        scales: {
          xAxes: [
            {
              distribution: "series",
              offset: true,
              type: "time",
              time: {
                unit: "month",
                displayFormats: {
                  year: "YYYY",
                  month: "YYYY/MM",
                  day: "M/DD",
                  hour: "HH",
                  minute: "H:mm",
                  second: "h:mm:ss",
                  millisecond: "h:mm",
                },
                tooltipFormat: "YYYY/MM",
              },
            },
          ],
          yAxes: [
            {
              //display:true,
              // scaleLabel: {
              //   display: true,
              //   labelString: this.$store.state.chartylabel
              // },
              ticks: {
                //min: 0,
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },
};
</script>




// WEBPACK FOOTER //
// src/components/presentation/chart/charttime.vue